import React from 'react';
import defaultClasses from './savedConfigurators.module.css';
import { useStyle } from '../lib/util/classify';
import classNames from '../lib/util/classNames';
import { array, shape, string } from 'prop-types';
import SavedConfiguratorItem from './savedConfiguratorItem';
import ConfiguratorGroupTitle from './configuratorGroupTitle.js';
// import ShareNative from './ShareIcons/ShareNative';
import ShareByEmail from './ShareIcons/ShareByEmail';
import Button from '../components/Button';
import { useSavedConfigurators } from '../talons/ProductConfigurator/useSavedConfigurators';
import { Price } from '../peregrine';

const SavedConfigurators = props => {
    const {
        wishlists,
        removeFromWishlist,
        updateGroupTitle,
        moveToGroup,
        isLoading,
        addGroupToCart,
        groups,
        totalPrices
    } = useSavedConfigurators(props);
    const classes = useStyle(defaultClasses, props.classes);

    const wishlistBlock = Object.entries(wishlists).map(([group, items]) => {
        // const totalPrice = totalPrices.get(group);
        return (
            <div className={classes.group} key={group}>
                <div className={classes.groupHeader}>
                    <ConfiguratorGroupTitle
                        initialTitle={group}
                        onSave={(newTitle, oldTitle) =>
                            updateGroupTitle(newTitle, oldTitle)
                        }
                    />
                    <div className={classes.shareIcons}>
                        {/* <span>
                            {_('Total price')}
                            {' '}
                            <Price value={totalPrice} currencyCode='EUR' />
                        </span> */}
                        <ShareByEmail
                            classes={classes}
                            title={_('e-Mail project')}
                            item={{
                                group,
                                wishlistItemId: items[0].wishlistItemId
                            }}
                        />
                        {/* <ShareNative
                                classes={classes}
                                item={{
                                    group,
                                    wishlistItemId: items[0].wishlistItemId
                                }}
                            /> */}
                        <Button
                            priority="high"
                            onClick={() => addGroupToCart(group)}
                            disabled={isLoading}
                            style={{ height: '100%' }}
                        >
                            {_('Add project to cart')}
                        </Button>
                    </div>
                </div>
                <div className={classes.itemlist}>
                    {items.map(item => (
                        <SavedConfiguratorItem
                            key={item.id}
                            item={item}
                            removeFromWishlist={removeFromWishlist}
                            isRemovingFromWishlist={isLoading}
                            group={group}
                            groups={groups}
                            onGroupChange={moveToGroup}
                        />
                    ))}
                </div>
            </div>
        );
    });

    return (
        <div
            className={classNames(
                wishlistBlock.length ? classes.root : classes.rootEmpty,
                isLoading && classes.loading
            )}
        >
            {wishlistBlock.length
                ? wishlistBlock
                : _('You have no configurations saved')}
        </div>
    );
};

SavedConfigurators.propTypes = {
    wishlists: array,
    clases: shape({
        root: string,
        loading: string,
        item: string,
        actions: string,
        button: string,
        icon: string
    })
};

export default SavedConfigurators;
